export const MAX_LOGO_HEIGHT = 60;
export const DEFAULT_LOGO_HEIGHT = 22;
